import type { ICustomControlData } from './TiecgV1DiagnosticReportAddEditCustomControlFields';
import { FormDivider, FormParagraph, ThirdHeader } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ReadAfwijkingen, showAfwijkingen } from '../../TCCr/v1/CardioAfwijkingen';

export function TiecgV1DiagnosticReportReadCustomControlFields(props: {
    customControlData: ICustomControlData;
    remark: string | null;
    txcsProcesId: string | null;
}) {
    const showHeaderInspanningEcg =
        props.customControlData.essentiele_veranderingen_in_het_ritme_geleiding_of_ST ||
        props.customControlData.toelichting ||
        props.customControlData.hartfrequentierespons_op_inspanning_is ||
        props.customControlData.bloeddruk_response ||
        props.customControlData.veranderingen_in_het_ECG_ritme ||
        props.remark;

    return (
        <>
            {showAfwijkingen(props.txcsProcesId, props.customControlData, 'conclusie_rust_ecg') && (
                <>
                    <ThirdHeader text={'Bevindingen rust ECG'} />
                    <ReadAfwijkingen afwijkingen={props.customControlData} />

                    <FormDivider />
                </>
            )}

            {showHeaderInspanningEcg && <ThirdHeader text={'Bevindingen inspannings ECG'} />}

            {props.customControlData.essentiele_veranderingen_in_het_ritme_geleiding_of_ST && (
                <HorizontalFormGroupRead>
                    <FormLabel>Essentiële veranderingen in het ritme, geleiding of ST</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.customControlData.essentiele_veranderingen_in_het_ritme_geleiding_of_ST}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.veranderingen_in_het_ECG_ritme && (
                <HorizontalFormGroupRead>
                    <FormLabel>Veranderingen in het ECG ritme</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.veranderingen_in_het_ECG_ritme}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.toelichting && (
                <HorizontalFormGroupRead>
                    <FormLabel>Toelichting</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.toelichting}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.hartfrequentierespons_op_inspanning_is && (
                <HorizontalFormGroupRead>
                    <FormLabel>Hartfrequentierespons op inspanning</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.hartfrequentierespons_op_inspanning_is}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.bloeddruk_response && (
                <HorizontalFormGroupRead>
                    <FormLabel>Bloeddruk response</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.bloeddruk_response}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
